// react-query queryKey SSOT. entity api hook 과 외부 호출처(invalidate / prefetch
// / getQueryData) 가 동일 키 공유. 도메인 담당은 entity 에 있되, 키 자체는
// 횡단 캐시 컨벤션이라 shared 정합 (cross-entity import 회피).

export const USER_PROFILE_QUERY_KEY = ['user', 'profile'] as const;
export const USER_ALARM_QUERY_KEY = ['user', 'alarm'] as const;
export const USER_CONSENTS_QUERY_KEY = ['user', 'consents'] as const;

// 공통 코드(다중 부모) — `parentCodes` 조합이 곧 캐시 단위. 세션 중 불변이라 STATIC 으로 1회만 조회한다.
export const commonCodesQueryKey = (parentCodes: string) => ['common-codes', parentCodes] as const;
